import React from "react";
import styles from "./LoadingContainer.module.scss";
const LoadingContainer = () => {
  return (
    <div className={styles.loadingContainer}>
      <span class="loader"></span>
    </div>
  );
};

export default LoadingContainer;
